const toneClasses = {
  success: 'bg-green-50 text-green-700 ring-green-200 dark:bg-green-500/10 dark:text-green-300 dark:ring-green-500/30',
  warning:
    'bg-amber-50 text-amber-800 ring-amber-200 dark:bg-amber-500/10 dark:text-amber-300 dark:ring-amber-500/30',
  danger: 'bg-red-50 text-red-700 ring-red-200 dark:bg-red-500/10 dark:text-red-300 dark:ring-red-500/30',
  info: 'bg-blue-50 text-blue-700 ring-blue-200 dark:bg-blue-500/10 dark:text-blue-300 dark:ring-blue-500/30',
  neutral:
    'bg-slate-100 text-slate-700 ring-slate-200 dark:bg-slate-700/50 dark:text-slate-200 dark:ring-slate-600',
};

export const StatusBadge = ({ children, tone = 'neutral', compact = false, className = '' }) => (
  <span
    className={`inline-flex items-center ring-1 ring-inset ${compact ? 'rounded-md px-2 py-0.5 text-[10px] font-medium leading-tight' : 'rounded-full px-2.5 py-1 text-xs font-semibold'} ${toneClasses[tone]} ${className}`}
  >
    {children}
  </span>
);
